<div class="row filter-type-selection-header">
  <div class="col-6"></div>
  <div class="col-6 text-right">{{ filter.listingStatusesSelection?.length || 0 }} Selected</div>
</div>
<div class="row filter-type-selection-body">
  <div class="col-6">
    <p-tree
      [value]="listingStatuses"
      (click)="formDirty = true"
      [(selection)]="filter.listingStatusesSelection"
      [propagateSelectionUp]="false"
      selectionMode="checkbox"
      (onNodeSelect)="sortSelection(filter.listingStatusesSelection)"
      emptyMessage="No records found"
    ></p-tree>
  </div>
  <div class="col-6">
    <p-tree
      class="selected-tree"
      (click)="formDirty = true"
      [value]="filter.listingStatusesSelection"
      [(selection)]="filter.listingStatusesSelection"
      selectionMode="checkbox"
      emptyMessage=" "
    ></p-tree>
  </div>
</div>
<!-- p-tree does not have implementation of value control accessor the hack below implements this -->
<fieldset ngModelGroup="listingStatuses">
  <input type="hidden" [(ngModel)]="filter.listingStatusesSelection" name="listingStatusesSelection" #listingStatusesSelection="ngModel" required />
  <div class="row">
    <div class="col=12">
      <span class="help-block">
        <span *ngIf="formDirty && listingStatusesSelection.invalid"> Please select an option </span>
      </span>
    </div>
  </div>
</fieldset>
